const shareConstants = {
  SHOW_MODAL:      'SHOW_MODAL',
  HIDE_MODAL:      'HIDE_MODAL',
  ADD_LINK:        'ADD_LINK',
  LOADING_SUCCESS: 'LOADING_SUCCESS',
};

export default shareConstants;